import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Formik } from 'formik';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';

import prizesClient from '../../../../clients/prizes';
import TextInput from '../../../../web-app-components/components/TextInput';

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: theme.spacing(2),
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    maxWidth: 480,
  },
  submit: {
    marginTop: theme.spacing(1),
    alignSelf: 'flex-start',
  },
}));

const validate = (values) => {
  const errors = {};
  if (!(values.Name && values.Name.trim())) {
    errors.Name = 'Pavadinimas privalomas';
  }
  return errors;
};

const NewPrize = () => {
  const classes = useStyles();
  const history = useHistory();
  const { path } = useRouteMatch();
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async (values) => {
    try {
      const payload = {
        Name: values.Name.trim(),
        Description: (values.Description || '').trim() || null,
        GoldPrice: 0,
        Distance: 0,
      };
      const result = await prizesClient.create(payload);
      const id =
        result?.documentId ??
        result?.id ??
        result?.data?.documentId ??
        result?.data?.id;
      enqueueSnackbar('Prizas sukurtas', { variant: 'success' });
      history.push(id ? path.replace('/new', `/${id}`) : path);
    } catch (error) {
      const msg =
        error?.response?.data?.error?.message ||
        error?.message ||
        'Nepavyko sukurti';
      enqueueSnackbar(msg, { variant: 'error' });
    }
  };

  return (
    <div>
      <Typography variant="h5" className={classes.header}>
        Naujas prizas
      </Typography>
      <Formik
        initialValues={{
          Name: '',
          Description: '',
        }}
        validate={validate}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form className={classes.form} onSubmit={handleSubmit} noValidate>
            <TextInput
              name="Name"
              label="Pavadinimas"
              value={values.Name}
              onChange={handleChange}
              error={touched.Name && Boolean(errors.Name)}
              helperText={touched.Name && errors.Name}
              required
              fullWidth
            />
            <TextInput
              name="Description"
              label="Aprašymas"
              value={values.Description}
              onChange={handleChange}
              multiline
              minRows={4}
              fullWidth
            />
            <Button
              className={classes.submit}
              type="submit"
              variant="contained"
              color="primary"
              disabled={isSubmitting}
            >
              Sukurti
            </Button>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default NewPrize;
